<template>
  <div class="container">
    <div class="signs">
      <img style="width:100%;" src="@/assets/images/contact/banner.png" alt />
      <img class="signs_title" src="@/assets/images/contact/banner_text.png" alt="">
    </div>
    <div class="title">联系方式</div>
    <div class="contact_box">
        <div class="contact_item">
            <div class="contact_container">
                <div class="contact_img">
                    <img src="@/assets/images/contact/together.png" alt="">
                </div>
                <div class="contact_text">
                    <div style="font-weight:600;margin-bottom:20px;">合作咨询</div>
                    <div style="margin-bottom:10px;">138-5140-8423</div>
                    <div>138-5140-9680</div>
                </div>
            </div>
        </div>
        <div class="contact_item">
            <div class="contact_container">
                <div class="contact_img">
                    <img src="@/assets/images/contact/suggest.png" alt="">
                </div>
                <div class="contact_text">
                    <div style="font-weight:600;margin-bottom:20px;">投诉建议</div>
                    <div>159-5166-2710</div>
                </div>
            </div>
        </div>
    </div>
    <div class="mapbox">
      <div id="allmap"></div>
      <div class="phone_box">
        <div class="phone_item">
            <img src="@/assets/images/contact/mobile.png" alt="">
            <div class="phone_title">联系电话</div>
            <!-- <div class="phone_number">025-86129993</div> -->
            <div class="phone_number">138-5140-8423</div>
            <div>138-5140-9680</div>
        </div>
        <div>
            <img src="@/assets/images/contact/email.png" alt="">
            <div class="phone_title">电子邮箱</div>
            <div>biz@bridgetek.cn</div>
        </div>
    </div>
    </div>
  </div>
</template>

<script>
import { MP } from "../map";
export default {
  data(){
    return {}
  },
  mounted() {
    this.$nextTick(function() {
      MP("8cjWFpzoZqbUGIsvjzvM6OkPERDzrY8S").then(BMap => {
        var map = new BMap.Map("allmap"); // 创建Map实例
        var point = new BMap.Point(118.779457,31.980162); // 创建点坐标
        var marker = new BMap.Marker(point); // 创建标注
        // map.addOverlay(marker); // 将标注添加到地图中
        var content = '<div style="display:flex;position: relative;"><img src="/static/map_logo.png" alt="" style="margin-right:28px;"><div><div style="font-size:24px;margin-bottom:22px;margin-top:19px;">步锐捷电子科技有限公司</div><div>南京市雨花台区花神大道90号中兴物联研发大楼<br>2号楼3层<div></div><div style="width: 0;height: 0;border-style: solid;border-width: 20px 20px 0 20px;border-color: #FD8415 transparent transparent transparent;position: absolute;bottom:-47px;"></div></div>'
        var label = new BMap.Label(content, {       // 创建文本标注
            position: point,
            offset: new BMap.Size(-210, -200)  
        })  
        map.addOverlay(label);                        // 将标注添加到地图中
        label.setStyle({ 
            backgroundColor:'#FD8415',                // 设置label的样式
            color: '#fff',
            fontSize: '18px',
            width: '588px',
            height: '165px',
            border:0,
            padding:'12px',
            borderRadius:'8px'
        })
        marker.setAnimation(BMAP_ANIMATION_BOUNCE);
        map.centerAndZoom(new BMap.Point(118.78099,31.981192), 18);
        map.enableScrollWheelZoom();
      });
    });
  }
};
</script>

<style scoped>

.signs {
  width: 100%;
  margin-bottom: 60px;
  position: relative;
}

.signs .signs_title {
    position: absolute;
    top:55%;
    left:32%;
    transform: translate(-50% ,-50%);
}

.title {
    text-align: center;
    font-size: 50px;
    color: #303133;
    font-weight: 600;
    margin-bottom: 76px;
}

.contact_box {
    width:1080px;
    margin:0 auto;
    display: flex;
    justify-content: space-between;
}

.contact_item {
    width: 480px;
    height: 162px;
    padding: 6px;
    border-radius: 4px;
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.05);
}

.contact_container {
    width: 100%;
    height: 150px;
    background-color: #F9FBFF;
    display: flex;
    justify-content: space-evenly;
    padding-top:14px;
}

.contact_img {
    width: 60px;
    height: 60px;
}

.contact_text {
    color: #303133;
    font-size: 22px;
}

.phone_box {
    width: 255px;
    height: 580px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.20); 
    padding: 35px;
    font-size: 18px;
    color: #303133;
    position: absolute;
    right:20px;
    top:17%;
}

.phone_item {
    margin-bottom:87px;
}

.phone_box img {
    margin-bottom:18px;
}

.phone_title {
    font-weight: 700;
    font-size: 22px;
    margin-bottom:32px;
}

.phone_number {
    margin-bottom:23px;
}

#allmap {
  width: 1200px;
  height: 700px;
  margin: 110px auto 130px;
  font-family: "微软雅黑";
  box-shadow: #ddd 0 0 5px 5px;
}

.mapbox {
  position: relative;
  border: 1px solid transparent;
  width: 1200px;
  margin: 0 auto;
  /* background-color: rgb(247,247,247); */
}

</style>



// WEBPACK FOOTER //
// src/components/Contact.vue